
import React, { FC } from 'react';

import {
    Row,
    Column,
    Spacer,
    Text
} from '@components/1-atoms';

import styled from '@emotion/native';
import { PartialDocDataType } from '@components/5-pages/8.Document/EstimateCreate';


const TotalRow = styled(Row)`
  border-top-width: 0.9px;
  border-top-color: black;
  border-bottom-width: 3px;
  border-bottom-color: black;
  border-bottom-style: double;
  padding-top: 6px;
  padding-bottom: 9px;
`;


type Props = {
    currency: string;
    data: PartialDocDataType
};

const DocumentSummary: FC<Props> = ({ currency, data, ...props }) => {

    return (
        <>
            <Row>
                <Column><Text small>Subtotal</Text></Column>
                <Column><Text small align="right" decimal /* currency={currency} */>{data?.subTotal}</Text></Column>
            </Row>
            <Spacer h={1} />

            <Row>
                <Column><Text small>Discount</Text></Column>
                <Column>
                    <Text small align="right">
                        -<Text decimal /* currency={currency} */>{data?.totalDiscount}</Text>
                    </Text>
                </Column>
            </Row>
            <Spacer h={1} />

            <Row>
                <Column><Text small>Total Before Taxes</Text></Column>
                <Column><Text small align="right" decimal /* currency={currency} */>{data?.totalBeforeTaxes}</Text></Column>
            </Row>
            <Spacer h={1} />

            <Row>
                <Column><Text small>Total Taxes</Text></Column>
                <Column><Text small align="right" decimal /* currency={currency} */>{data?.totalTaxes}</Text></Column>
            </Row>
            <Spacer h={1} />

            <TotalRow>
                <Column><Text bold small>Total</Text></Column>
                <Column><Text bold small align="right" currency={currency}>{data?.grandTotal}</Text></Column>
            </TotalRow>
            <Spacer h={1} />
        </>
    );

};

export default DocumentSummary;